/* eslint-disable react/prop-types */
import React, { useState } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { useSoftUIController } from "context";
import UseWindowDimension from "hooks/UseWindowDimension";
import { Typography } from "@mui/material";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  minWidth: 400,
  bgcolor: "background.paper",
  border: "none",
  outline: "none",
  boxShadow: 24,
  borderRadius: 1,
  p: 1,
};

const Tabs = ({ tab, setTab, list, pickAll }) => {
  const [controller] = useSoftUIController();
  const { miniSidenav } = controller;
  const [open, setOpen] = useState(false);

  const handleChange = (newValue) => {
    setTab(newValue);
    setOpen(false);
  };

  return (
    <div
      style={{
        position: "fixed",
        bottom: 0,
        left: !miniSidenav ? 314 : 144,
        zIndex: 1,
        background: "#fff",
        border: "1px solid black",
        overflowX: "auto",
      }}
    >
      <button
        style={{
          padding: "4px 10px",
          margin: 4,
        }}
        onClick={() => setOpen(true)}
      >
        Chọn tab
      </button>

      <Modal
        open={open}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        onClose={() => setOpen(false)}
      >
        <Box sx={style}>
          <Box
            sx={{
              p: 1,
              border: "1px solid black",
              borderRadius: 1,
            }}
          >
            <Typography id="modal-modal-title" variant="h6" component="h2">
              Chọn tab
            </Typography>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 2,
                mt: 1,
                maxHeight: 400,
                overflow: "auto",
              }}
            >
              <button
                style={{
                  padding: "6px 10px",
                  background: tab === 0 ? "#17c1e8" : "#fff",
                  color: tab === 0 ? "white" : "inherit",
                  outline: "none",
                  border: "1px solid gray",
                  borderRadius: 4,
                  cursor: "pointer",
                }}
                onClick={() => handleChange(0)}
              >
                Tờ khai
              </button>
              {list &&
                list.length > 0 &&
                list.map((item, index) => (
                  <button
                    style={{
                      padding: "6px 10px",
                      background: tab === index + 1 ? "#17c1e8" : "#fff",
                      color: tab === index + 1 ? "white" : "inherit",
                      outline: "none",
                      border: "1px solid gray",
                      borderRadius: 4,
                      cursor: "pointer",
                      display: !item.disabled && (pickAll || item.checked) ? "block" : "none",
                    }}
                    onClick={() => handleChange(index + 1)}
                    key={index}
                  >
                    {item.name}
                  </button>
                ))}
            </Box>
          </Box>
        </Box>
      </Modal>
    </div>
  );
};

export default Tabs;
